"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.building_modern = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var building_modern = function building_modern(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'building-modern-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M17.5058 2.44619C17.6614 2.58828 17.75 2.78928 17.75 3V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17V4.27273C2.25 3.88483 2.54579 3.56093 2.9321 3.52581L16.9321 2.25308C17.142 2.23401 17.3502 2.30409 17.5058 2.44619ZM3.75 4.95764V16.25H7.75V12C7.75 11.5858 8.08579 11.25 8.5 11.25H11.5C11.9142 11.25 12.25 11.5858 12.25 12V16.25H16.25V3.82128L3.75 4.95764ZM10.75 16.25V12.75H9.25V16.25H10.75ZM7.75 8C7.75 7.58579 8.08579 7.25 8.5 7.25H11.5C11.9142 7.25 12.25 7.58579 12.25 8C12.25 8.41422 11.9142 8.75 11.5 8.75H8.5C8.08579 8.75 7.75 8.41422 7.75 8Z',
    fill: '#4B5563'
  }));
};

exports.building_modern = building_modern;